import { render, staticRenderFns } from "./CandidateSuccessModal.vue?vue&type=template&id=5730d1d8"
import script from "./CandidateSuccessModal.vue?vue&type=script&lang=js"
export * from "./CandidateSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports